module.exports = __webpack_public_path__ + "img/menu5.8cb48241.png";